import React from 'react';
import { Zap } from 'lucide-react';
import { CHECKOUT_URL, CHECKOUT_VARIANT_ID, OFFER_ANCHOR, PRODUCT_NAME } from '../data/checkout';
import { todayPrice } from '../data/valueStack';
import { trackAddToCart } from '../utils/metaPixel';
type CtaButtonProps = {
  label: string;
  href?: string;
  className?: string;
  size?: 'md' | 'lg';
};
export function CtaButton({
  label,
  href = OFFER_ANCHOR,
  className = '',
  size = 'md'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'w-full px-5 py-4 text-[12.5px] sm:w-auto sm:px-10 sm:py-5 sm:text-[15px]' : 'w-full px-5 py-3.5 text-[11.5px] sm:w-auto sm:px-8 sm:py-4 sm:text-[13.5px]';
  const isCheckout = href === CHECKOUT_URL;
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    // AddToCart sólo se dispara en el botón que lleva al checkout de Shopify.
    if (!isCheckout) return;
    if (event.defaultPrevented) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault();
    trackAddToCart({
      content_name: PRODUCT_NAME,
      content_ids: [CHECKOUT_VARIANT_ID],
      content_type: 'product',
      value: todayPrice,
      currency: 'USD'
    });

    // Pequeña espera para que el pixel alcance a enviar el evento antes de salir.
    window.setTimeout(() => {
      window.location.href = href;
    }, 260);
  };
  return <a href={href} onClick={handleClick} className={`group ease-luxe relative inline-flex max-w-full items-center justify-center gap-2.5 overflow-hidden rounded-lg border border-[#fff4d6]/60 bg-gradient-to-b from-[#e6c983] via-gold-400 to-gold-500 text-center font-extrabold uppercase leading-tight tracking-[0.02em] text-[#1a1305] shadow-[0_16px_36px_-10px_rgba(201,162,74,0.55),inset_0_1px_0_rgba(255,255,255,0.5)] transition-transform duration-300 hover:-translate-y-0.5 hover:scale-[1.02] active:scale-[0.99] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold-200 sm:animate-cta-glow ${sizing} ${className}`} data-id="element-38" data-mp="3ouyzyia6p20e">
      <Zap className="h-4 w-4 shrink-0" strokeWidth={2.4} aria-hidden="true" data-id="element-39" data-mp="3hz5l8331weun" />
      <span className="relative z-10" data-id="element-40" data-mp="hmdojir26gc">{label}</span>
      <span className="pointer-events-none absolute inset-0 hidden -translate-x-full bg-gradient-to-r from-transparent via-white/45 to-transparent transition-transform duration-700 group-hover:translate-x-full sm:block" aria-hidden="true" data-id="element-41" data-mp="jfjjwljgmna" />
    </a>;
}